import { useSession } from '@lib/auth/session';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoutes = (): JSX.Element => {
  const loggedIn = useSession();

  return loggedIn ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoutes;
